import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import PropTypes from "prop-types";
import AreaHelper from "./areaChartHelper";
import "./AreaChartWithAxis.scss";

class AreaChartWithAxis extends Component {
  state = {
    margin: { top: 20, right: 20, bottom: 30, left: 40 },
    barColors: ["#5262ad", "#3bcbe3", "#999999"],
    width: this.props.width,
    height: this.props.height,
    portfolio: [],
    benchmark: [],
    getOrigPortfolioVami: [],
  };

  componentDidMount() {
    const { Portfolio, Benchmark, getOrigPortfolioVami } = this.props;
    this.setState({
      portfolio: Portfolio,
      benchmark: Benchmark,
      getOrigPortfolioVami: getOrigPortfolioVami,
    });
    let modifiedData = AreaHelper.modifyData({
      portfolio: Portfolio,
      benchmark: Benchmark,
      orig_portfolio: getOrigPortfolioVami,
    });

    setTimeout(() => this.displayChart(modifiedData), 0);
  }

  componentWillReceiveProps(nextProps) {
    const {
      Portfolio,
      Benchmark,
      width,
      height,
      id,
      getOrigPortfolioVami,
    } = nextProps;
    if (
      JSON.stringify(Portfolio) !== JSON.stringify(this.props.Portfolio) ||
      JSON.stringify(Benchmark) !== JSON.stringify(this.props.Benchmark) ||
      JSON.stringify(getOrigPortfolioVami) !==
        JSON.stringify(this.props.getOrigPortfolioVami) ||
      width !== this.props.width
    ) {
      $(`#${id}`).empty();
      this.setState({
        height,
        width,
        portfolio: Portfolio,
        benchmark: Benchmark,
        getOrigPortfolioVami: getOrigPortfolioVami,
      });

      let modifiedData = AreaHelper.modifyData({
        portfolio: Portfolio,
        benchmark: Benchmark,
        orig_portfolio: getOrigPortfolioVami,
      });

      setTimeout(() => this.displayChart(modifiedData), 0);
    }
  }

  displayChart = (data) => {
    if (!data) return;
    const {
      margin,
      barColors,
      width,
      height,
      portfolio,
      benchmark,
      getOrigPortfolioVami,
    } = this.state;
    let display_orig_portfolio = this.props.display_orig_portfolio;

    $(`#${id}`).empty();
    const { id } = this.props;

    data.forEach(function (d) {
      d.x = new Date(d.x);
    });

    var x = d3.time.scale().range([0, width]);

    x.domain([
      d3.min(data, function (e) {
        return e.x;
      }),
      d3.max(data, function (el) {
        return el.x;
      }),
    ]);

    var y = d3.scale
      .linear()
      .domain([
        d3.min(data, function (d) {
          let y = [];
          y.push(d.y1);
          y.push(d.y2);
          if (d.y3) {
            y.push(d.y3);
          }
          return d3.min(y);
        }),
        d3.max(data, function (d) {
          let x = [];
          x.push(d.y1);
          x.push(d.y2);
          if (d.y3) {
            x.push(d.y3);
          }
          return d3.max(x);
        }),
      ])
      .range([height, 0]);

    var xAxis = d3.svg.axis().scale(x).orient("top");

    var yAxis = d3.svg.axis().scale(y).orient("left");

    var area1 = d3.svg
      .area()
      .interpolate("monotone")
      .x(function (d) {
        return x(d.x);
      })
      .y0(y(0))
      .y1(function (d) {
        return y(d.y2);
      });

    var area2 = d3.svg
      .area()
      .interpolate("monotone")
      .x(function (d) {
        return x(d.x);
      })
      .y0(y(0))
      .y1(function (d) {
        return y(d.y1);
      });

    var area3 = d3.svg
      .area()
      .interpolate("monotone")
      .x(function (d) {
        return x(d.x);
      })
      .y0(y(0))
      .y1(function (d) {
        return y(d.y3);
      });

    var svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("class", "MultiAreaChart")
      .attr("width", width + margin.right + margin.left)
      .attr("height", height + margin.right)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg
      .append("g")
      .attr("class", "parent")
      .append("path")
      .datum(data)
      .style("fill", "#8775a7")
      // .attr("class", "areaPath3")
      .attr("d", area3);

    svg
      .append("g")
      .attr("class", "parent")
      .append("path")
      .datum(data)
      // .attr("class", "areaPath2")
      .style("fill", " #5262ade8")
      .attr("d", area2);

    svg
      .append("g")
      .attr("class", "parent")
      .append("path")
      .datum(data)
      // .attr("class", "areaPath1")
      .style("fill", "#3bcbe380")
      .attr("d", area1);

    // .append("title")
    // .text("Area 2");

    let aAxis_y_align_point =
      data && data.length > 0 && data.map((e) => e.y1).includes(0)
        ? y(0)
        : y(
            d3.max(data, function (e) {
              return e.y1;
            })
          );
    console.log({ data });
    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + aAxis_y_align_point + ")")
      .call(xAxis);

    svg.append("g").attr("class", "y axis").call(yAxis);

    // ***************  tooltip ***************
    // converting data
    let convertDate = (date) => {
      var event = new Date(date);

      let d = JSON.stringify(event);
      d = d.slice(1, 11);

      return d;
    };

    // let portfolio_modify = Portfolio;
    // let benchmark_modify = Benchmark;

    // portfolio_modify.forEach(function(d) {
    //   d.value = +d.value;
    //   d.date = convertDate(d.date);
    // });

    var pathLine = svg
      .append("g")
      .attr("class", "pathLine")
      .style("display", "none");

    pathLine
      .append("path") // vertical line to follow mouse
      .attr("id", `focus-path-${this.props.id}`)
      .style("stroke", "#aaa")
      .style("stroke-width", "1px");

    var tooltipHolder = svg
      .append("g")
      .attr("class", "tooltipHolder")
      .style("display", "none");

    this.toolTip_svg([svg, this.props.id, tooltipHolder]);

    function mousemove() {
      var mouse = d3.mouse(this);

      let date = x.invert(mouse[0]);

      let benchmark_filter = benchmark.filter(function (el) {
        return el.dt >= convertDate(date);
      });

      let portfolio_filter = portfolio.filter(function (el) {
        return el.dt >= convertDate(date);
      });

      let orig_portfolio_filter = [];
      if (getOrigPortfolioVami) {
        orig_portfolio_filter = getOrigPortfolioVami.filter(function (el) {
          return el.dt >= convertDate(date);
        });
      }
      if (mouse[0] > width / 2) {
        let x = mouse[0] - 110;
        tooltipHolder.attr("transform", "translate(" + x + "," + 0 + ")");
      } else {
        tooltipHolder.attr(
          "transform",
          "translate(" + mouse[0] + "," + 0 + ")"
        );
      }

      let textOne;
      let portfolioValue;
      let benchmarkValue;
      let Orig_portfolio_value = null;

      if (portfolio_filter.length > 0) {
        portfolioValue = d3.round(portfolio_filter[0].drawdown, 4);
      } else {
        portfolioValue = 0;
      }

      if (benchmark_filter.length > portfolio_filter.length) {
        textOne = benchmark_filter[0].dt;
      } else {
        textOne = portfolio_filter[0].dt;
      }

      if (benchmark_filter.length > 0) {
        benchmarkValue = d3.round(benchmark_filter[0].drawdown, 4);
      } else {
        benchmarkValue = 0;
      }

      if (orig_portfolio_filter.length > 0) {
        Orig_portfolio_value = d3.round(orig_portfolio_filter[0].drawdown, 4);
      } else {
        Orig_portfolio_value = null;
      }

      d3.select(`#text-one-${id}`).text(textOne ? textOne : 0);
      d3.select(`#text-two-${id}`).text(
        `● B${display_orig_portfolio ? "*" : ""} :` + benchmarkValue + "K"
      );
      d3.select(`#text-three-${id}`).text("● P : " + portfolioValue + "K");
      if (display_orig_portfolio) {
        d3.select(`#text-four-${id}`).text(
          "● O : " +
            Orig_portfolio_value +
            `${orig_portfolio_filter === null ? null : "K"}`
        );
      }

      d3.select(`#focus-path-${id}`).attr("d", function () {
        var d = "M" + mouse[0] + "," + height;
        d += " " + mouse[0] + "," + 40;
        return d;
      });
    }
    svg
      .append("rect")
      .attr("class", "overlay")
      .attr("width", width)
      .attr("height", height)
      .style("fill", "none")
      .on("mouseover", function () {
        pathLine.style("display", null);
        tooltipHolder.style("display", null);
      })
      .on("mouseout", function () {
        pathLine.style("display", "none");
        tooltipHolder.style("display", "none");
      })
      .on("mousemove", mousemove);
  };

  toolTip_svg = (props) => {
    var svg = props[0],
      chartId = props[1],
      tooltipHolder = props[2];
    svg.append("g").attr("class", "tooltipHolder").style("display", "none");

    tooltipHolder
      .append("rect")
      .attr("y", 27)
      .attr("width", 110)
      .attr("height", 75)
      .style("fill", "#000000db");

    tooltipHolder
      .append("text")
      .attr("id", `text-one-${chartId}`)
      .attr("x", 10)
      .attr("y", 35)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#fff");

    tooltipHolder
      .append("text")
      .attr("id", `text-two-${chartId}`)
      .attr("x", 10)
      .attr("y", 50)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#6d9cf3");

    tooltipHolder
      .append("text")
      .attr("id", `text-three-${chartId}`)
      .attr("x", 10)
      .attr("y", 65)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#81efde");

    tooltipHolder
      .append("text")
      .attr("id", `text-four-${chartId}`)
      .attr("x", 10)
      .attr("y", 80)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#8775a7");
  };

  render() {
    return <div id={this.props.id} />;
  }
}

AreaChartWithAxis.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  display_orig_portfolio: PropTypes.bool,
  Portfolio: PropTypes.arrayOf(PropTypes.object).isRequired,
  Benchmark: PropTypes.arrayOf(PropTypes.object).isRequired,
  getOrigPortfolioVami: PropTypes.arrayOf(PropTypes.object),
};
export default AreaChartWithAxis;



// WEBPACK FOOTER //
// ./src/components/d3Components/multiAreaChart/AreaChartWithAxis/AreaChartWithAxis.jsx